import { useEffect, useState, useRef } from 'react'
import { DocumentArrowDownIcon, PlusIcon } from '@heroicons/react/24/outline'
import 'styles/TimingDataEdit.css'
import { parseDate } from 'utils'
import { makeRequest } from 'services/request.service'
import ButtonComponent from 'components/common/ButtonComponent'
import TableComponent from 'components/common/TableComponent'
import TimingDataEditModal from 'components/modals/TimingDataEditModal'
import { useAuth } from 'auth/AuthContext'

export default function TimingDataEdit () {
  const hasFetched = useRef(false)
  const { user } = useAuth()
  const [state, setState] = useState({
    timingData: [],
    currentDate: parseDate(new Date()),
    searchTerm: '',
    isTimingDataModalOpen: false
  })

  const onTimingModalToogle = () => setState(s => ({
    ...s,
    isTimingDataModalOpen: !state.isTimingDataModalOpen
  }))

  const getTimingData = async () => {
    try {
      const response = await makeRequest({
        method: 'GET',
        url: `/management/data-edit/timing-data/${user.farmId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        }
      })

      setState({ ...state, timingData: response.data })
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const postTimingData = async () => {
    try {
      const response = await makeRequest({
        method: 'POST',
        url: `/management/data-edit/timing-data/${user.farmId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('secret')}`
        }
      })
      setState({ ...state, timingData: response.data })
    } catch (error) {
      console.error('Error:', error)
    }
  }

  const filterTimingData = () => {
    return state.timingData.filter(timing =>
      timing.rowCode.toLowerCase().includes(state.searchTerm) ||
      timing.date.toLowerCase().includes(state.searchTerm) ||
      timing.time.toLowerCase().includes(state.searchTerm) ||
      timing.timingScanType.toLowerCase().includes(state.searchTerm) ||
      timing.workerName.toLowerCase().includes(state.searchTerm) ||
      timing.block.toLowerCase().includes(state.searchTerm) ||
      timing.activityName.toLowerCase().includes(state.search)
    )
  }

  // mocked data, replace with API
  const workersListMock = [
    { id: 1, name: 'Worker 1' },
    { id: 2, name: 'Worker 2' },
    { id: 3, name: 'Worker 3' },
    { id: 4, name: 'Worker 4' },
    { id: 5, name: 'Worker 5' }
  ]

  const timingTableData = {
    hascheckbox: true,
    columns: [
      { key: 'timingDataId', label: '#' },
      { key: 'rowCode', label: 'Row Code' },
      { key: 'date', label: 'Date' },
      { key: 'time', label: 'Time' },
      { key: 'timingScanType', label: 'Scan Type' },
      { key: 'workerName', label: 'Worker' },
      { key: 'block', label: 'Block' },
      { key: 'farmingBlockId', label: 'Farming Block Id' }, // map to workers name
      { key: 'activityName', label: 'Activity' }
    ],
    rows: filterTimingData
  }

  useEffect(() => {
    if (hasFetched.current) return
    hasFetched.current = true

    getTimingData()
  }, [])

  return (
    <div className='p-6 bg-white shadow-md border border-gray-300 border-t-0'>
      <div className='section-header'>
        <div className='header-left'>
          <div className='date-filter'>
            <span>Today ({state.currentDate})</span>
          </div>
        </div>
        <div className='flex items-center gap-4 mb-6'>
          <ButtonComponent onClick={onTimingModalToogle}>
            <PlusIcon className='w-5 h-5' />
            Create Timings
          </ButtonComponent>
          <ButtonComponent className='flex items-center gap-2'>
            <DocumentArrowDownIcon className='w-5 h-5' />
            <span>Export as Excel</span>
          </ButtonComponent>
          <ButtonComponent className='flex items-center gap-2'>
            <DocumentArrowDownIcon className='w-5 h-5' />
            <span>Export as PDF</span>
          </ButtonComponent>
        </div>
      </div>

      <div className='search-container'>
        <input
          type='text'
          placeholder='Search'
          value={state.searchTerm}
          onChange={(e) => setState(s => ({ ...s, searchTerm: e.target.value.toLowerCase() }))}
          className='search-input'
        />
      </div>

      {timingTableData.rows.length !== 0 && (
        <TableComponent tableData={timingTableData} defaultSortColumn={timingTableData.columns[0]?.key} />
      )}

      {state.isTimingDataModalOpen && (
        <TimingDataEditModal
          isOpen={state.isTimingDataModalOpen}
          onClose={onTimingModalToogle}
          onSave={postTimingData}
          initialData={state.timingData}
          workersList={workersListMock} // replace with API response
        />
      )}
    </div>
  )
}
